import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CandidateProAction2 } from "../../../Redux/action/CandidateProAction2";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { CandidateUpdateProImg } from "../../../Redux/action/CandidateUpdateProImgAction";
import {
  fetchDepartmentDetails,
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import { useCountries } from "../../../Hooks/useCountries";
import { useStatesByCountry } from "../../../Hooks/useStatesByCountry";
import { useCitiesByState } from "../../../Hooks/useCitiesByState";
import getCroppedImg from "../../../utils/CropImg";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { useNavigate } from "react-router";

import { CiEdit } from "react-icons/ci";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiForbid2Line } from "react-icons/ri";

import {
  Box,
  Grid,
  Avatar,
  TextField,
  Typography,
  IconButton,
  Button,
  MenuItem,
  Switch,
  TextareaAutosize,
  Divider,
  Tooltip,
  FormHelperText,
  FormControl,
} from "@mui/material";

import Select from "react-select";
import dummyDp from "../../../images/dummy_dp.png";

const themeColor = "#286a94";

const UpdateProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userResult } = useSelector((state) => state.Auth);
  const userInfo = useSelector((state) => state.Profile.result);

  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content
  );
  const AllDepartmentList = useSelector(
    (state) => state?.MasterTableDetails?.department?.content
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );

  const candidateId = userResult?.userid;

  const [isDisabled, setIsDisabled] = useState(true);
  const [openCrop, setOpenCrop] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const [image, setImage] = useState(dummyDp);
  const [tempPro, setTempPro] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropPixels, setCropPixels] = useState(null);
  const [errors, setErrors] = useState({});

  const [profileInfo, setProfileInfo] = useState({
    firstName: "",
    lastName: "",
    currentDesignation: "",
    overview: "",
    keyExperience: "",
    keyExperienceInMonth: "",
    gender: "",
    state: "",
    pincode: "",
    city: "",
    country: "",
    availableForWork: false,
    department: "",
    address: "",
    skillList: [],
  });

  const { data: countries } = useCountries();
  const { data: stateList } = useStatesByCountry(
    profileInfo?.country || "India"
  );
  const { data: cityData } = useCitiesByState(
    profileInfo?.country,
    profileInfo?.state
  );

  useEffect(() => {
    dispatch(CandidateProfile(candidateId));
    dispatch(fetchSkillDetails());
    dispatch(fetchDepartmentDetails());
    dispatch(fetchDesignationDetails());
  }, []);

  useEffect(() => {
    if (userInfo) {
      setProfileInfo({
        ...userInfo,
        keyExperience: userInfo?.keyExperience,
        keyExperienceInMonth: userInfo?.keyExperienceInMonth,
      });

      setSelectedSkills(
        userInfo?.skillList?.map((item) => ({ label: item, value: item })) || []
      );

      setImage(userInfo?.profileImageUrl || dummyDp);
    }
  }, [userInfo]);

  const handleChange = (e) =>
    setProfileInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSkillsChange = (skills) => {
    setSelectedSkills(skills);
    setProfileInfo({ ...profileInfo, skillList: skills.map((s) => s.value) });
  };

  const fileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return toast.error("Upload an image");

    const sizeMB = file.size / (1024 * 1024);
    if (sizeMB > 1 || sizeMB < 0.004)
      return toast.error("Image must be between 4KB - 1MB");

    const reader = new FileReader();
    reader.onloadend = () => {
      setTempPro(reader.result);
      setOpenCrop(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCropSubmit = async () => {
    const croppedFile = await getCroppedImg(tempPro, cropPixels);
    const formData = new FormData();
    formData.append("image", croppedFile);
    formData.append("candidateId", candidateId);

    dispatch(CandidateUpdateProImg(formData)).then(() => {
      dispatch(CandidateProfile(candidateId));
      setOpenCrop(false);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("candidateReqDto", JSON.stringify(profileInfo));
    if (!validateProfile()) {
      toast.error("Please complete the required fields.");
      return;
    }
    await dispatch(CandidateProAction2(formData, navigate));
    setIsDisabled(true);
  };

  const validateProfile = () => {
    let newErrors = {};

    const requiredFields = [
      "firstName",
      "lastName",
      "currentDesignation",
      "gender",
      "department",
      "country",
      "state",
      "city",
      "pincode",
      "address",
      "keyExperience",
      "overview",
    ];

    requiredFields.forEach((field) => {
      const value = profileInfo[field];

      if (
        value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      ) {
        const formattedField = field
          .replace(/([A-Z])/g, " $1")
          .trim()
          .replace(/^./, (c) => c.toUpperCase());

        newErrors[field] = `${formattedField} is required`;
      }
    });

    if (!profileInfo.skillList || profileInfo.skillList.length === 0) {
      newErrors.skillList = "At least one skill is required";
    }

    if (profileInfo.firstName && !/^[A-Za-z\s]+$/.test(profileInfo.firstName)) {
      newErrors.firstName = "First name must contain only letters";
    }

    if (profileInfo.lastName && !/^[A-Za-z\s]+$/.test(profileInfo.lastName)) {
      newErrors.lastName = "Last name must contain only letters";
    }

    if (profileInfo.overview && profileInfo.overview.length < 30) {
      newErrors.overview = "Overview must be at least 30 characters";
    }

    if (profileInfo.pincode && !/^\d{5,10}$/.test(profileInfo.pincode)) {
      newErrors.pincode = "Pincode must be 5–10 digits";
    }

    if (profileInfo.address && profileInfo.address.length < 10) {
      newErrors.address = "Address must be at least 10 characters long";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      {/* Cropper Modal */}
      <Modal show={openCrop} onHide={() => setOpenCrop(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: 400 }}>
          <Cropper
            image={tempPro}
            crop={crop}
            zoom={zoom}
            cropShape="round"
            onCropChange={setCrop}
            onCropComplete={(area, pixelArea) => setCropPixels(pixelArea)}
            onZoomChange={setZoom}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            sx={{ bgcolor: themeColor }}
            variant="contained"
            onClick={handleCropSubmit}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------- MAIN CONTENT WITHOUT EXTRA CARD ------- */}
      <Box sx={{ maxWidth: "900px", mx: "auto", p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" fontWeight={700} sx={{ color: "#193563" }}>
            Profile Settings
          </Typography>
          <Typography variant="body2" sx={{ color: "red", mt: 0.5 }}>
            Fields marked with * are required
          </Typography>

          <Tooltip title={isDisabled ? "Edit Profile" : "Disable Editing"}>
            <IconButton
              sx={{
                backgroundColor: isDisabled ? "#e3eefc" : "#ffe2e2",
                "&:hover": {
                  backgroundColor: isDisabled ? "#c9ddfa" : "#ffcccc",
                },
                transition: "background-color 0.3s ease",
              }}
              onClick={() => setIsDisabled(!isDisabled)}
            >
              {isDisabled ? (
                <CiEdit size={22} />
              ) : (
                <RiForbid2Line size={22} color="red" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
        <Divider sx={{ my: 2 }} />
        {/* ========= SECTION: PROFILE IMAGE ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Profile Picture <span style={{ color: "red", marginLeft: 4 }}>*</span>
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={4} textAlign="center">
            <Avatar
              src={image}
              sx={{
                width: 150,
                height: 150,
                mx: "auto",
                border: `3px solid ${themeColor}`,
              }}
            />

            {!isDisabled && (
              <Button
                component="label"
                variant="outlined"
                sx={{ mt: 2, borderColor: themeColor, color: themeColor }}
                startIcon={<IoCloudUploadOutline />}
              >
                Upload
                <input hidden type="file" onChange={fileChange} />
              </Button>
            )}
          </Grid>
        </Grid>

        {/* ========= SECTION: PERSONAL INFORMATION ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Personal Information
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="First Name"
              required
              disabled={isDisabled}
              name="firstName"
              value={profileInfo.firstName}
              onChange={handleChange}
              error={Boolean(errors.firstName)}
              helperText={errors.firstName}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last Name"
              required
              disabled={isDisabled}
              name="lastName"
              error={Boolean(errors.lastName)}
              helperText={errors.lastName}
              value={profileInfo.lastName}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    fontSize: "20px",
                    color: "red", // makes the * red
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Gender"
              name="gender"
              error={Boolean(errors.gender)}
              helperText={errors.gender}
              value={profileInfo.gender}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ mb: 1, fontWeight: 600, color: themeColor }}>
              Professional Summary <span style={{ color: "red" }}>*</span>
            </Typography>

            <FormControl fullWidth error={Boolean(errors.overview)}>
              <TextareaAutosize
                minRows={4}
                disabled={isDisabled}
                name="overview"
                placeholder="Write a short professional summary..."
                value={profileInfo.overview}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "14px",
                  border: Boolean(errors.overview)
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: 6,
                  fontSize: "16px",
                  fontFamily: "Roboto, sans-serif",
                  boxSizing: "border-box",
                }}
              />

              {errors.overview && (
                <FormHelperText>{errors.overview}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>

        {/* ========= SECTION: PROFESSIONAL ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Professional Details
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Designation"
              name="currentDesignation"
              error={Boolean(errors.currentDesignation)}
              helperText={errors.currentDesignation}
              value={profileInfo.currentDesignation}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {AllDesignationList?.map((d) => (
                <MenuItem key={d.designationId} value={d.designation}>
                  {d.designation}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Department"
              name="department"
              error={Boolean(errors.department)}
              helperText={errors.department}
              value={profileInfo.department}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {AllDepartmentList?.map((d) => (
                <MenuItem key={d.departmentId} value={d.departmentName}>
                  {d.departmentName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Experience (Years)"
              name="keyExperience"
              error={Boolean(errors.keyExperience)}
              helperText={errors.keyExperience}
              value={String(profileInfo.keyExperience)?.replace(/[^0-9]/g, "")}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  keyExperience: e.target.value,
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {[...Array(31)].map((_, i) => (
                <MenuItem key={i} value={i}>
                  {i} Years
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              disabled={isDisabled}
              label="Experience (Months)"
              name="keyExperienceInMonth"
              value={String(profileInfo.keyExperienceInMonth)?.replace(
                /[^0-9]/g,
                ""
              )}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  keyExperienceInMonth: e.target.value,
                })
              }
            >
              {[...Array(12)].map((_, i) => (
                <MenuItem key={i} value={i}>
                  {i} Months
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        {/* ========= SKILLS ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Skills <span style={{ color: "red" }}>*</span>
        </Typography>

        <FormControl fullWidth error={Boolean(errors.skillList)} sx={{ mt: 2 }}>
          <Select
            isMulti
            isDisabled={isDisabled}
            value={selectedSkills}
            onChange={handleSkillsChange}
            options={AllSkillList?.map((s) => ({
              label: s.skillName,
              value: s.skillName,
            }))}
            styles={{
              container: (base) => ({
                ...base,
                backgroundColor: "#fff",
              }),

              control: (base, state) => ({
                ...base,
                backgroundColor: "#fff",
                borderRadius: 10,
                padding: 6,
                borderColor: Boolean(errors.skillList) ? "red" : themeColor,
                boxShadow: "none",
                "&:hover": {
                  borderColor: Boolean(errors.skillList) ? "red" : themeColor,
                },
              }),

              menu: (base) => ({
                ...base,
                backgroundColor: "#fff",
                zIndex: 9999,
              }),

              menuList: (base) => ({
                ...base,
                backgroundColor: "#fff",
              }),

              multiValue: (base) => ({
                ...base,
                backgroundColor: themeColor,
                color: "#fff",
                fontWeight: 600,
              }),

              multiValueLabel: (base) => ({
                ...base,
                color: "#fff",
              }),

              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? themeColor : "#fff",
                color: state.isSelected ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: themeColor,
                  color: "#fff",
                },
              }),
            }}
          />

          {errors.skillList && (
            <FormHelperText sx={{ color: "red", mt: 0.5 }}>
              {errors.skillList}
            </FormHelperText>
          )}
        </FormControl>

        {/* ========= LOCATION ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mt: 4, mb: 2, color: themeColor }}
        >
          Location
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              disabled={isDisabled}
              label="Address"
              name="address"
              value={profileInfo.address}
              error={Boolean(errors.address)}
              helperText={errors.address}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Country"
              name="country"
              error={Boolean(errors.country)}
              helperText={errors.country}
              value={profileInfo.country}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  country: e.target.value,
                  state: "",
                  city: "",
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {countries?.data?.map((c) => (
                <MenuItem key={c.country} value={c.country}>
                  {c.country}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="State"
              name="state"
              error={Boolean(errors.state)}
              helperText={errors.state}
              value={profileInfo.state}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  state: e.target.value,
                  city: "",
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {stateList?.data?.states?.map((s) => (
                <MenuItem key={s.name} value={s.name}>
                  {s.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="City"
              name="city"
              error={Boolean(errors.city)}
              helperText={errors.city}
              value={profileInfo.city}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            >
              {cityData?.map((c) => (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              disabled={isDisabled}
              label="Pincode"
              name="pincode"
              error={Boolean(errors.pincode)}
              helperText={errors.pincode}
              value={profileInfo.pincode}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red", // makes the * red
                  },
                },
              }}
            />
          </Grid>
        </Grid>

        {/* ========= TOGGLE ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Preferences
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography>Available for work</Typography>
          <Switch
            disabled={isDisabled}
            checked={profileInfo.availableForWork}
            onChange={() =>
              setProfileInfo({
                ...profileInfo,
                availableForWork: !profileInfo.availableForWork,
              })
            }
          />
        </Box>

        {!isDisabled && (
          <Button
            sx={{
              mt: 4,
              bgcolor: themeColor,
              ":hover": { bgcolor: "#1f5678" },
            }}
            variant="contained"
            onClick={handleSubmit}
          >
            Save Changes
          </Button>
        )}
      </Box>
    </>
  );
};

export default UpdateProfile;
